export const SCHOOL_LEVELS = [
  {
    name: "پیش دبستانی",
    value: 1,
    color: "#FFC6C7",
    gradeOptions: [
      { name: "پیش یک", value: -1 },
      { name: "پیش دو", value: -2 },
    ],
  },
  {
    name: "ابتدایی اول",
    value: 2,
    color: "#87F7F9",
    gradeOptions: [
      { name: "اول", value: 1 },
      { name: "دوم", value: 2 },
      { name: "سوم", value: 3 },
    ],
  },
  {
    name: "ابتدایی دوم",
    value: 3,
    color: "#C2FCD9",
    gradeOptions: [
      { name: "چهارم", value: 4 },
      { name: "پنجم", value: 5 },
      { name: "ششم", value: 6 },
    ],
  },
  {
    name: "متوسطه اول",
    value: 4,
    color: "#BFCFFF",
    gradeOptions: [
      { name: "هفتم", value: 7 },
      { name: "هشتم", value: 8 },
      { name: "نهم", value: 9 },
    ],
  },
  {
    name: "متوسطه دوم",
    value: 5,
    color: "#F8A978",
    gradeOptions: [
      { name: "دهم", value: 10 },
      { name: "یازدهم", value: 11 },
      { name: "دوازدهم", value: 12 },
    ],
  },
];
